import { combineReducers } from 'redux';
import languageProviderReducer from './containers/language-provider/reducer';
import curriculumListReducer from './containers/curriculum-list/reducer';
import masterCoursesReducer from './containers/master-courses/reducer';
import toastReducer from './components/toast/reducer';

const reducers = combineReducers({
    product: state => ({ ...state }),
    language: languageProviderReducer,
    curriculumList: curriculumListReducer,
    masterCourses: masterCoursesReducer,
    toast: toastReducer
});

export default reducers;



// WEBPACK FOOTER //
// ./app/reducers.js